import { AlertOctagon } from "lucide-react";
import { Button } from "./ui/button";
import { Link } from "@remix-run/react";

export default function ErrorPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-emerald-50 px-4">
      <div className="w-full max-w-md text-center">
        <AlertOctagon className="mx-auto mb-6 text-red-500" size={80} />
        <h1 className="mb-4 text-3xl font-bold text-gray-800">
          Oops! Something Went Wrong
        </h1>
        <p className="mb-6 text-gray-600">
          We're experiencing an unexpected error. Please try again later or{" "}
          <button
            onClick={() => $crisp?.push(["do", "chat:open"])}
            className="font-medium underline decoration-emerald-500 underline-offset-2 hover:decoration-2"
          >
            contact support
          </button>{" "}
          if the problem persists.
        </p>
        <div className="flex justify-center space-x-4">
          <Button onClick={() => window.location.reload()}>Reload Page</Button>
          <Button onClick={() => window.history.back()} variant="outline">
            Go Back
          </Button>
        </div>
      </div>
    </div>
  );
}
